/* istanbul ignore file */
import useInvoiceService, { REJECT_INVOICE, INVOICE_STATUSES } from 'domain/finance/invoice/useInvoiceService';
import { useParams } from 'react-router-dom';
import { DeleteButton } from 'framework/ui/ui-builder';
import { useFieldHelper } from 'framework/ui/field';
import { useShowContext } from 'framework/show';

const deleteMessage = 'Do you really want to cancel this invoice payment?';

const CancelPaymentInvoiceButton = ({ statusSource }: { statusSource: string }) => {
  const { id } = useParams<Dictionary<string>>();
  const { cancelInvoicePayment, invalidateCache } = useInvoiceService();
  const { getValue } = useFieldHelper({ source: statusSource });
  const { setData = () => {} } = useShowContext();
  const status = getValue();

  if (status !== INVOICE_STATUSES.PAID) {
    return null;
  }

  return (
    <DeleteButton
      displayMessage={deleteMessage}
      deleteMethod={() => cancelInvoicePayment(id!)}
      afterDelete={{
        successMessage: 'The Invoice payment has been successfully canceled.',
        errorMessage: "Can't cancel invoice payment.",
        execute: (data: any) => {
          invalidateCache();
          setData(data);
        },
      }}
      permissionToCheck={REJECT_INVOICE}
      buttonText="Cancel payment"
      color="error"
    />
  );
};

export default CancelPaymentInvoiceButton;
